<script setup>
</script>

<template>
  <div class="legal-footer-link noprint">
    <a href="/legal" target="_blank" rel="noopener noreferrer">Términos, privacidad y uso de datos</a>
  </div>
</template>

<style scoped>
.legal-footer-link {
  position: fixed;
  left: max(env(safe-area-inset-left, 0px), 10px);
  bottom: max(env(safe-area-inset-bottom, 0px), 8px);
  z-index: 30;
  pointer-events: none;
}

.legal-footer-link a {
  pointer-events: auto;
  font-size: 11px;
  color: var(--label-tertiary, #999);
  background: var(--bg-primary, #fff);
  border: 1px solid var(--separator, rgba(0, 0, 0, 0.1));
  border-radius: 999px;
  padding: 3px 10px;
  text-decoration: none;
  opacity: 0.75;
  -webkit-tap-highlight-color: transparent;
}

.legal-footer-link a:hover,
.legal-footer-link a:active {
  opacity: 1;
}
</style>
